// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "SelfServConfigCreateDto" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { HeaderAlignment } from "./header-alignment.enum.gen";
import { TreeStatus } from "./tree-status.enum.gen";

export const SelfServConfigCreateDtoGenShape = z.strictObject({
  teamId: z.string(),
  groupId: z.string(),
  domain: z.string(),
  teamName: z.string(),
  logoImage: z.string(),
  headerAlignment: z.enum(HeaderAlignment),
  customCss: z.string(),
  status: z.enum(TreeStatus),
  startText: z.string(),
  contactText: z.string(),
  disclaimer: z.string(),
  homeLink: z.string(),
  housingLink: z.string(),
  feedbackLink: z.string(),
  privacyLink: z.string(),
  contactLink: z.string(),
  hideContactBtn: z.boolean(),
  selfReferralUrl: z.string(),
  email: z.string(),
  telephone: z.string(),
  information: z.string(),
  emergencyContact: z.string(),
  address: z.string(),
  translationUrl: z.string(),
  externalDomain: z.string(),
  gaKey: z.string(),
  hotjarId: z.string(),
  accessibleLinkText: z.boolean(),
});
